import { type Accessor, createContext, useContext } from "solid-js";

export interface SpeechProviderContextInterface {
	isListening: Accessor<boolean>;
	read: (text: string) => void;
	stop: () => void;
}

export const SpeechContext = createContext<SpeechProviderContextInterface>();

export function useSpeech() {
	const context = useContext(SpeechContext);
	if (!context) throw new Error("useSpeech must be used within a SpeechProvider");
	return context;
}
